import { useGetOrgId } from '@shared/hooks/use-get-org-id';
import { createRoute, PATHS } from '@src/core/router/paths';
import { useGetOrganizationById } from '@shared/services/get-organization-by-id';
import { useNavigate } from 'react-router-dom';
import { ReminderBar } from './reminder-bar';
import { useGetMe } from '@shared/services/get-me';

export const AppMainReminder = () => {
  const navigate = useNavigate();
  const orgId = useGetOrgId();
  const { data: orgData } = useGetOrganizationById(orgId);
  const { data: user } = useGetMe();
  const orgIsCompleted = orgData?.profile?.is_completed;
  const profileIsCompleted = user?.profile?.is_completed;

  let reminderProps: React.ComponentProps<typeof ReminderBar> | null = null;

  if (!orgIsCompleted && user?.is_owner) {
    reminderProps = {
      progressText: 'Organization information is not complete',
      message: 'Please complete your information.',
      buttonText: 'Organization Information',
      onButtonClick: () => navigate(createRoute(PATHS.EDIT_ORG_INFO)),
      hiddenOnPages: [PATHS.EDIT_ORG_INFO, PATHS.SETTINGS_PROFILE_SETTINGS],
      hidable: true,
    };
  } else if (!profileIsCompleted) {
    reminderProps = {
      progressText: 'Profile information is not complete',
      message: 'Please complete your information.',
      buttonText: 'Profile Information',
      onButtonClick: () =>
        navigate(createRoute(PATHS.SETTINGS_PROFILE_SETTINGS)),
      hiddenOnPages: [PATHS.SETTINGS_PROFILE_SETTINGS],
      hidable: true,
    };
  }

  return reminderProps ? <ReminderBar {...reminderProps} /> : null;
};
